export default "__VITE_ASSET__gZkj8eIa__"